// extracted by mini-css-extract-plugin
export default {"box":"ContentsBox_box__ivyTA","intro":"ContentsBox_intro__jbiju","context":"ContentsBox_context__iJfp4"};